import { Field, RadioGroup } from 'Components/Core';
import withInjectedProps from 'Components/Core/InjectedPropsContext/withInjectedProps';
import ListFieldSection from 'Components/Layout/FieldSection/ListFieldSection';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import React from 'react';
import { MaterialConditionAsTested } from '../../types';

let AsPreparationAlternativeSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Natural State Preparation">
        <Field
          input={<RadioGroup />}
          name="MaterialConditionAsTested"
          options={[
            { label: 'Whole sample used', value: MaterialConditionAsTested.Natural },
            { label: 'Rubbed through sieve', value: MaterialConditionAsTested.Rubbed },
          ]}
        ></Field>
      </ListFieldSection>
    </>
  );
};

AsPreparationAlternativeSection = withInjectedProps(AsPreparationAlternativeSection);

export { AsPreparationAlternativeSection };
export default AsPreparationAlternativeSection;
